export default "__VITE_ASSET__LPXsmwr7__"